import classNames from 'classnames';
import { FC } from 'react';

import ResetFilter from '@/features/resetFilter/ResetFilter';
import { declension } from '@/shared/lib';

import styles from './filterResultPanel.module.scss';

interface FilterResultPanelProps {
  title: string;
  count: number;
  className?: string;
  onClear: () => void;
}

const FilterResultPanel: FC<FilterResultPanelProps> = (props) => {
  const { title, count, className, onClear } = props;
  return (
    <div className={classNames(className, styles.panel)}>
      <p className={styles.panel__text}>
        По запросу #{title} найдено {count}{' '}
        {declension(count ?? 0, ['статья', 'статьи', 'статей'])}
      </p>
      <ResetFilter onClick={onClear} />
    </div>
  );
};

export default FilterResultPanel;
